import { useEffect, useState } from 'react';

interface Service {
  id: number;
  icon: string;
  title: string;
  description: string;
  url: string;
}

export default function ServicesSection() {
  const [services, setServices] = useState<Service[]>([]);
  const [heroImage, setHeroImage] = useState<string | null>(null);

  useEffect(() => {
    async function fetchServices() {
      try {
        const res = await fetch(
          'https://blog.thecryptotutor.com/wp-json/wp/v2/pages?slug=home'
        );
        const pages = await res.json();
        if (!pages.length) return;

        const page = pages[0];

        // Set services using new ACF fields
        setServices([
          {
            id: 1,
            icon: 'ri-exchange-line',
            title: page.acf?.service_title_1 || 'Crypto Exchange Reviews',
            description: page.acf?.service_1_description || 'Compare top exchanges',
            url: page.acf?.service_url_1 || '#',
          },
          {
            id: 2,
            icon: 'ri-wallet-3-line',
            title: page.acf?.service_title_2 || 'Wallet Reviews',
            description: page.acf?.service_1_description_copy || 'Secure your assets',
            url: page.acf?.service_url_2 || '#',
          },
          {
            id: 3,
            icon: 'ri-book-open-line',
            title: page.acf?.service_title_3 || 'DeFi Guides',
            description: page.acf?.service_1_description_copy2 || 'Master decentralized finance',
            url: page.acf?.service_url_3 || '#',
          },
        ]);

        // Fetch services section hero image from media ID
        if (page.acf?.services_section_image) {
          try {
            const imgRes = await fetch(
              `https://blog.thecryptotutor.com/wp-json/wp/v2/media/${page.acf.services_section_image}`
            );
            const imgData = await imgRes.json();
            setHeroImage(imgData.source_url || null);
          } catch (e) {
            console.error('Error fetching services section image from media ID:', e);
          }
        }
      } catch (e) {
        console.error('Error fetching Services ACF or hero image:', e);
      }
    }

    fetchServices();
  }, []);

  return (
    <section className="py-10 bg-[#F5F7FA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left - Services List */}
          <div className="space-y-6">
            {services.map((service) => (
              <a
                key={service.id}
                href={service.url}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                <div className="flex items-start space-x-4 bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                  <div className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${service.icon} text-black text-3xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-1">{service.title}</h3>
                    <p className="text-gray-600">{service.description}</p>
                  </div>
                </div>
              </a>
            ))}
          </div>

          {/* Right - Hero Image */}
          <div className="flex justify-center">
            <div className="relative w-140 h-140 overflow-hidden flex items-center justify-center">
              {heroImage ? (
                <img
                  src={heroImage}
                  alt="Services Hero"
                  className="w-full h-full object-cover rounded-lg"
                />
              ) : (
                <span className="text-gray-400">Loading image...</span>
              )}

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
